module.exports = __webpack_public_path__ + "media/images/suceess-story8-18fa3a1a2ff2e05cd61140c67ab8f923.jpg";